import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigDataProvider } from '../config-data/config-data';
import { Attachments } from '../../Interface/CommonDataBaseInterface';

@Injectable()
export class AttachmentsStoreProvider {

	public db = new DatabaseProvider();
	public attachmentsList: BehaviorSubject<any> = new BehaviorSubject([]);
	private sourcePath = "";
	private customerCode = "";
	constructor(
		private configDataProvider: ConfigDataProvider
	) {
		this.sourcePath = this.configDataProvider.getcaredocurl();
		this.customerCode = this.configDataProvider.getCustomerCode();
	}

	addBatch(attachmentsList) {

		return new Promise((resolve, reject) => {

			let list = this.manipulateListBeforeInsert(attachmentsList);

			this.db.attachments.clear().then(() => {

				this.db.attachments.bulkAdd(list).then((data) => {
					resolve(data)
				}).catch((e) => {
					reject(e);
				})

			}).catch((e) => {
				reject(e);
			})

		})

	}

	manipulateListBeforeInsert(list) {

		this.sourcePath = this.configDataProvider.getcaredocurl();
		this.customerCode = this.configDataProvider.getCustomerCode();

		let attachmentList = []

		if (list && list.length > 0) {

			list.forEach((val) => {
				// var filename = val.diskname;
				let filepath = "";

				filepath = this.sourcePath + '/customerspaces/' + this.customerCode + '/attachments/' + val.diskname;

				// filepath = cordova.file.dataDirectory + 'attachments';
				// if (!ionic.Platform.isAndroid() && !ionic.Platform.isIOS() && !ionic.Platform.isIPad())
				// 	filepath = $rootScope.caredocurl + '/customerspaces/' + $rootScope.customercode + '/attachments/' + val.diskname;
				// else
				// 	filepath = cordova.file.dataDirectory + 'attachments/' + val.diskname;


				var attachmentData = {
					id: val.id,
					name: val.diskname,
					diskname: val.diskname,
					messageid: val.messageid,
					filepath: filepath,
					mime: val.mime,
					filetype: val.filetype,
					customercode: val.customercode,
					appstatus: ""
				}
				attachmentList.push(attachmentData);
			})

		}

		return attachmentList;

	}


	getAll() {

		return new Promise((resolve, reject) => {

			this.db.attachments.toArray().then((data) => {

				let list = [];

				if (data && data.length > 0) {
					list = [...data]
				}

				resolve(list);

			}).catch((e) => {
				reject(e);
			})

		})

	}


	getAttachments(list) {

		let finalList = [];
		let newAttachmentsData = [];

		return new Promise((resolve, reject) => {

			this.getAll().then((allAttachments: any) => {

				if (list && list.length > 0) {

					list.forEach((value) => {

						var res = allAttachments.filter((val) => {
							return val.messageid == value.id;
						})

						if (res && res.length > 0) {
							res.forEach((tmpRes) => {
								newAttachmentsData.push(tmpRes);
							})
						}

					})

					if (newAttachmentsData && newAttachmentsData.length > 0) {
						newAttachmentsData.forEach((tmpAttach) => {

							// let messageId = tmpAttach.messageid;

							let attribute = {};
							for (let key in tmpAttach) {

								if (key == 'filepath') {

									attribute[key] = tmpAttach[key];

									// if ((!ionic.Platform.isAndroid() && !ionic.Platform.isIOS() && !ionic.Platform.isIPad()))
									// 	attribute['ffilepath'] = attribute[key];
									// else {
									// 	if (cordova.platformId == "browser") {
									// 		attribute['ffilepath'] = attribute[key];
									// 	} else {
									// 		let attf = toolsService.getFilePath('attachments');
									// 		attribute['ffilepath'] = attf;
									// 	}
									// }

								} else {
									attribute[key] = tmpAttach[key];
								}
							}
							attribute['isNew'] = false;
							finalList.push(attribute);
						})
					}
					resolve(finalList);
				}

			}).catch((e) => {
				resolve([])
			})

		})

	}

	addAttachments(attachment: Attachments) {

		return new Promise((resolve, reject) => {


			this.db.attachments.add(attachment).then((data) => {

				resolve(data);

			}).catch((e) => {

				reject(e);

			});

		})
	}

}



// WEBPACK FOOTER //
// ./src/providers/attachments-store/attachments-store.ts